import { lazy } from "react";

import Campaigns from "./pages/Campaigns";
import Settings from "./pages/Settings";
import Analytics from "./pages/Analytics";
import RevenueByMember from "./pages/RevenueByMember";
import RevenueByGroup from "./pages/RevenueByGroup";
import GroupDetails from "./pages/GroupDetails";
import Members from "./pages/Members";
import GroupsManager from "./pages/GroupsManager";
import ProductCatalog from "./pages/ProductCatalog";
import Integrations from "./pages/Integrations";
import Surveys from "./pages/Surveys";
import Users from "./pages/Users";

const DevicesLocations = lazy(() => import("./pages/DevicesLocations"));
const UserGuide = lazy(() => import("./pages/UserGuide"));
const ApiDocs = lazy(() => import("./pages/ApiDocs"));
const VerifyEmail = lazy(() => import("./pages/VerifyEmail"));
const EmailVerifiedMessage = lazy(() => import("./pages/EmailVerifiedMessage"));
const BlockDevice = lazy(() => import("./pages/BlockDevice"));
const LoginVerified = lazy(() => import("./pages/LoginVerified"));
const AccessDenied = lazy(() => import("./pages/AccessDenied"));
const NotFound = lazy(() => import("./pages/NotFound"));
const PublicSurvey = lazy(() => import("./pages/PublicSurvey"));
const AcceptInvite = lazy(() => import("./pages/AcceptInvite"));
const AccountSecurity = lazy(() => import("./pages/AccountSecurity"));

export const privateRoutes = [
  {
    path: "/campaigns",
    element: <Campaigns />,
  },
  {
    path: "/members/groups",
    element: <GroupsManager />,
  },
  {
    path: "/members/list",
    element: <Members />,
  },
  {
    path: "/analytics",
    element: <Analytics />,
  },
  {
    path: "/analytics/revenue-by-member",
    element: <RevenueByMember />,
  },
  {
    path: "/analytics/revenue-by-group",
    element: <RevenueByGroup />,
  },
  {
    path: "/members/groups/:groupId",
    element: <GroupDetails />,
  },
  // {
  //   path: "/events",
  //   element: <Events />,
  // },
  {
    path: "/item-catalog",
    element: <ProductCatalog />,
  },
  {
    path: "/integrations",
    element: <Integrations />,
  },
  {
    path: "/surveys",
    element: <Surveys />,
  },
  {
    path: "/settings",
    element: <Settings/>,
  },
  {
    path: "/users",
    element: <Users />,
  },
  {
    path: "/devices-locations",
    element: <DevicesLocations />,
  },
  {
    path: "/user-guide",
    element: <UserGuide />,
  },
  {
    path: "/api-docs",
    element: <ApiDocs />,
  },
  {
    path: "/account/security",
    element: <AccountSecurity />,
  },
];

export const publicRoutes = [
  // {
  //   path: "/signup",
  //   element: <SignUp />,
  // },
  {
    path: "/survey/:surveyId",
    element: <PublicSurvey />,
  },
  {
    path: "/auth/verify",
    element: <VerifyEmail />,
  },
  {
    path: "/email-verified",
    element: <EmailVerifiedMessage />,
  },
  {
    path: "/block-device",
    element: <BlockDevice />,
  },
  {
    path: "/verify-login",
    element: <LoginVerified />,
  },
  {
    path: "/access-denied",
    element: <AccessDenied />,
  },
  {
    path: "/invite/:token",
    element: <AcceptInvite />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
